import publicApiClient from "./publicApiClient";
import apiClient from "./apiClient";
import authService from "auth/authService";

export interface SignInPayload {
  identifier: string;
  password: string;
}

export interface SignInResponse {
  customToken: string;
  sessionExpiresAt: number;
  /** Server-declared tenant. Absent from older backends; null means the default pool. */
  tenantId?: string | null;
}

export async function signInApi(payload: SignInPayload): Promise<SignInResponse> {
  const res = await publicApiClient.post("/auth/sign-in", payload);
  return res.data;
}

/**
 * Password reset, sent via the backend rather than the Firebase client SDK.
 *
 * The client cannot choose the pool: auth.tenantId is null on the login page, so a browser-side
 * reset always targets the default pool — not the password a migrated user signs in with. The
 * server resolves the pool, mails a temporary password, and tells us nothing about whether the
 * address existed.
 */
export async function forgotPasswordApi(email: string): Promise<void> {
  await publicApiClient.post("/auth/forgot-password", { email });
}

export async function signOutApi(): Promise<void> {
  await apiClient.post("/auth/sign-out");
}

export async function refreshSessionApi(): Promise<{
  sessionExpiresAt: number;
}> {
  const idToken = await authService.getToken();
  const res = await publicApiClient.post(
    "/auth/refresh",
    {},
    { headers: idToken ? { Authorization: `Bearer ${idToken}` } : {} },
  );
  return res.data;
}

export async function getAppTokenApi(
  clientPub: string,
): Promise<{ token: string; serverPub: string; expiresIn?: number }> {
  const idToken = await authService.getToken();
  const res = await publicApiClient.post(
    "/auth/app-token",
    { clientPub },
    { headers: idToken ? { Authorization: `Bearer ${idToken}` } : {} },
  );
  return res.data;
}
